export enum PointCategory {
  EQUIPE = 'equipe',
  CANAL = 'canal',
}
